import {
  FolderMajor,
  CustomersMajor,
  OrdersMajor,
  NotificationMajor,
  PackageMajor,
  FormsMajor,
  CategoriesMajor,
  HashtagMajor,
  ConfettiMajor,
  ViewMajor,
  LegalMajor,
  StoreMajor,
  PaymentsMajor,
  FraudProtectPendingMajor,
  DomainNewMajor,
  QuestionMarkMajor,
  SmileyHappyMajor,
  SettingsMinor,
  ChatMajor,
  ClipboardMinor,
  NoteMajor,
  ChecklistMajor,
  EmailMajor,
  ToolsMajor,
  EmailNewsletterMajor,
  MarketingMajor,
  PageDownMajor,
  SocialAdMajor,
  DiscountCodeMajor,
  InventoryMajor,
} from "@shopify/polaris-icons";
import Logo_dark from "media/Logo.svg";
import Logo_light from "media/Logo.svg";
import { Navigation, Page, Link } from "@shopify/polaris";
import { useAppSelector } from "../config/store";
import { useLocation } from "react-router-dom";
import { ItemProps } from "@shopify/polaris/build/ts/latest/src/components/Navigation/components";
import { Box } from "@mui/material";
import { BiSolidReport } from "react-icons/bi";
import { FaBook, FaPodcast, FaUsers } from "react-icons/fa";
import { PiExamFill } from "react-icons/pi";
import { FaSpeakap } from "react-icons/fa";
import { MdGrading } from "react-icons/md";
import { GrConfigure } from "react-icons/gr";
import { BiSolidCategory } from "react-icons/bi";
import { RiCommunityFill, RiCoupon3Fill } from "react-icons/ri";
import { MdStarRate } from "react-icons/md";
import { GiArrowScope } from "react-icons/gi";
import { IoChatboxEllipses } from "react-icons/io5";
import { USER_ROLE, resolveRole } from "constant/roles";
/**
 * Public, no login
 */
const navigationItems: ItemProps[] = [
  // {
  //   url: "/",
  //   label: "Trang chủ",
  //   icon: HomeMajor,
  //   subNavigationItems: [
  //     {
  //       url: "/",
  //       exactMatch: true,
  //       label: "Mới nhất",
  //     },
  //     {
  //       url: "/dashboard/customer",
  //       label: "Hot nhất",
  //     },
  //     {
  //       url: "/dashboard/order",
  //       label: "Dành cho bạn",
  //     },
  //   ],
  // },
  // {
  //   url: "/pages",
  //   label: "Pages",
  //   icon: BlogMajor,
  // },

  {
    url: "/media",
    label: "Media",
    icon: FolderMajor,
  },

  // {
  //   url: "/chat",
  //   label: "Chat",
  //   icon: ChatMajor,
  // },

  {
    url: "/notification",
    label: "Notification",
    icon: NotificationMajor,
  },

  // {
  //   url: "/banner",
  //   label: "Banner",
  //   icon: SlideshowMajor,
  // },

  {
    url: "/report",
    label: "Contact Form",
    icon: FormsMajor,
  },
];

const orderMenuItems = [
  {
    url: "/order",
    label: "Đơn hàng",
    icon: PaymentsMajor,
  },
  {
    url: "/transaction",
    label: "Giao dịch",
    icon: LegalMajor,
  },
];

// const eventMenuItems = [
//   {
//     url: "/event",
//     label: "Event",
//     icon: ConfettiMajor,
//   },

//   {
//     url: "/rating",
//     label: "Rating",
//     icon: ViewMajor,
//   },
//   {
//     url: "/city",
//     label: "City",
//     icon: StoreMajor,
//   },
//   {
//     url: "/type",
//     label: "Type",
//     icon: HashtagMajor,
//   },
//   {
//     url: "/category",
//     label: "Category",
//     icon: CategoriesMajor,
//   },
// ];

const otherMenuItems = [
  {
    url: "/prompt",
    label: "Prompt",
    icon: NoteMajor,
  },

  {
    url: "/user_question",
    label: "User Question",
    icon: QuestionMarkMajor,
  },

  {
    url: "/user_interest",
    label: "User Interest",
    icon: SmileyHappyMajor,
  },

  {
    url: "/chat_system",
    label: "Chat System",
    icon: FraudProtectPendingMajor,
  },
];

/**
 * For admin
 */
const adminMenuItems = [
  // {
  //   url: "/email_setup",
  //   label: "Email setup",
  //   icon: EmailMajor,
  //   subNavigationItems: [
  //     {
  //       url: "/email_setup",
  //       icon: HorizontalDotsMinor,
  //       exactMatch: true,
  //       label: "Email setup",
  //     },
  //     {
  //       url: "/email_template",
  //       icon: HorizontalDotsMinor,
  //       label: "Email template",
  //     },
  //     {
  //       url: "/email_queue",
  //       icon: HorizontalDotsMinor,
  //       label: "Email queue",
  //     },
  //   ],
  // },

  {
    url: "/report-revenue",
    label: "Report revenue",
    icon: CustomersMajor,
  },
  {
    url: "/users",
    label: "Users",
    icon: CustomersMajor,
  },

  {
    url: "/category",
    label: "Category",
    icon: CategoriesMajor,
  },

  // {
  //   url: "/user_question",
  //   label: "User Question",
  //   icon: QuestionMarkMajor,
  // },

  // {
  //   url: "/user_interest",
  //   label: "User Interest",
  //   icon: SmileyHappyMajor,
  // },

  {
    url: "/podcast",
    label: "Podcast",
    icon: FolderMajor,
  },
  {
    url: "/mission",
    label: "Mission",
    icon: ChecklistMajor,
  },
  {
    url: "/course",
    label: "Course",
    icon: ClipboardMinor,
  },
  {
    url: "/practice-exam",
    label: "Practice Exam",
    icon: PageDownMajor,
  },
  {
    url: "/practice-speaking",
    label: "Practice Speaking",
    icon: PageDownMajor,
  },
  {
    url: "/grading-test/list",
    label: "Grading test",
    icon: PageDownMajor,
  },
  {
    url: "/config-page",
    label: "Config",
    icon: PageDownMajor,
  },
  // {
  //   url: "/chat_system",
  //   label: "Chat System",
  //   icon: FraudProtectPendingMajor,
  // },
  {
    url: "/community",
    label: "Community",
    icon: SocialAdMajor,
  },
  {
    url: "/evaluation",
    label: "Evaluation",
    icon: SocialAdMajor,
  },

  {
    url: "/coupon",
    label: "Coupon",
    icon: DiscountCodeMajor,
  },

  {
    url: "/club",
    label: "Club",
    icon: InventoryMajor,
  }
];

/**
 * START ...
 * @returns
 */
function NavMakeUp() {
  const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);

  // const isAdmin = account.user_role === "admin";
  const location = useLocation();
  const version = process.env.REACT_APP_VERSION;
  /**
   *
   */
  /*
    useEffect( () => {
      if (isAuthenticated)
        navigations = navigationItems.concat(navigationItemsForLoginUser);
    }, [isAuthenticated]);
  */
  const account = useAppSelector((state) => state.user.account);
  const role = resolveRole(account);
  const isAdmin = role === USER_ROLE.ADMIN;
  const isTeacher = role === USER_ROLE.TEACHER;
  const isUser = role === USER_ROLE.USER;
  const isCommunityModerator = role === USER_ROLE.COMMUNITY_MODERATOR;
  return (
    <Navigation location={location.pathname}>
      {!isCommunityModerator && (
        <Navigation.Section title="Quản trị Giao dịch" items={orderMenuItems} />
      )}
      {isCommunityModerator && (
        <Navigation.Section
          title="Cộng đồng"
          items={[{ url: "/community", label: "Cộng đồng", icon: RiCommunityFill }]}
        />
      )}
      {/* <Navigation.Section items={navigationItems} /> */}
      {/* <Navigation.Section title="Quản trị Events" separator items={eventMenuItems} /> */}
      {/* {isAdmin ? */}
      {/* {(isAdmin || isTeacher) && (
        <Navigation.Section
          title="Quản trị chung"
          separator
          items={adminMenuItems}
        />
      )} */}
      {(isAdmin || isTeacher) && (
        <>
          <Navigation.Section
            title="Báo cáo & Người dùng"
            separator
            items={[
              {
                url: "/report-revenue",
                label: "Báo cáo doanh thu",
                icon: BiSolidReport,
              },
              { url: "/users", label: "Người dùng", icon: CustomersMajor },
            ]}
          />

          <Navigation.Section
            title="Khóa học & Luyện tập"
            separator
            items={[
              { url: "/course", label: "Khóa học", icon: FaBook },
              {
                url: "/practice-exam",
                label: "Luyện thi",
                icon: PiExamFill,
              },
              {
                url: "/practice-speaking",
                label: "Luyện nói",
                icon: FaSpeakap,
              },
              {
                url: "/grading-test/list",
                label: "Chấm điểm bài thi",
                icon: MdGrading,
              },
            ]}
          />

          <Navigation.Section
            title="Hệ thống & Cấu hình"
            separator
            items={[
              {
                url: "/config-page",
                label: "Cấu hình hệ thống",
                icon: GrConfigure,
              },
              { url: "/category", label: "Danh mục", icon: BiSolidCategory },
            ]}
          />

          <Navigation.Section
            title="Cộng đồng & Quản lý nội dung"
            separator
            items={[
              { url: "/community", label: "Cộng đồng", icon: RiCommunityFill },
              { url: "/chat", label: "Quản lý chat", icon: IoChatboxEllipses },
              { url: "/evaluation", label: "Đánh giá", icon: MdStarRate },
              { url: "/podcast", label: "Podcast", icon: FaPodcast },
              { url: "/mission", label: "Nhiệm vụ", icon: GiArrowScope },
              { url: "/club", label: "Câu lạc bộ", icon: FaUsers },
            ]}
          />

          <Navigation.Section
            title="Ưu đãi & Giảm giá"
            separator
            items={[
              { url: "/coupon", label: "Mã giảm giá", icon: RiCoupon3Fill },
            ]}
          />
        </>
      )}

      {/* : null} */}
      <Navigation.Section fill items={[]} />
      <Page fullWidth>
        <div style={{ fontSize: "11px" }}>
          &copy; 2024 IKES, ver: {version} <br />
        </div>
      </Page>
    </Navigation>
  );
}
export default NavMakeUp;
